module.exports = __webpack_public_path__ + "img/sk.e8420452.svg";